import { Component, OnInit } from '@angular/core';
import { SettingService } from 'src/app/system-common/services/setting.service';
import { AgentService } from '../services/agent.service';
import { AgentReviewApplicationHandler } from './agent-review-application.handler';

@Component({
  selector: 'sym-agent-review-application',
  templateUrl: './agent-review-application.component.html',
  styleUrls: ['./agent-review-application.component.scss'],
})
export class AgentReviewApplicationComponent extends AgentReviewApplicationHandler {
  currViewImageModel: any;
  display: number = 0;
  headIdentity: boolean;
  headEducation: boolean;
  headPartyEmployment: boolean;
  headQuestion: boolean;
  headFamilyList: boolean;
  headRefList: boolean;
  headTrain: boolean;
  headbank: boolean;
  headexam: boolean;
  headagency: boolean;
  headNominee: boolean;
  headdocument: boolean;
  headSignature: boolean;
  imageExtension: string[];
  counterIdentity: number = 0;
  counterEducation: number = 0;
  counterPartyEmployement: number = 0;
  counterTrain: number = 0;
  counterBank: number = 0;
  counterExam: number = 0;
  counterAgency: number = 0;
  counterNominee: number = 0;
  counterDocument: number = 0;
  counterSignature: number = 0;
  counterFamily: number = 0;
  counterQuestionList: number = 0;
  counterReferenceList: number = 0;

  constructor(agentService: AgentService, public settingService: SettingService) {
    super(agentService, settingService);

    this.headIdentity = false;
    this.headEducation = false;
    this.headQuestion = false;
    this.headFamilyList = false;
    this.headRefList = false;
    this.headTrain = false;
    this.headbank = false;
    this.headexam = false;
    this.headagency = false;
    this.headNominee = false;
    this.headdocument = false;
    this.headSignature = false;
    this.headPartyEmployment = false;
    if (this.service && this.service.responseIO && this.service.responseIO.data != undefined) {
      if (
        this.service.responseIO.data.AgentParty &&
        this.service.responseIO.data.AgentParty.IdentityList != undefined
      )
        for (let identity of this.service.responseIO.data.AgentParty.IdentityList) {
          this.counterIdentity = this.counterIdentity + 1;
          if (this.counterIdentity === 1) {
            if (identity.identityTypeCd != null || identity.identityNum != null) {
              this.headIdentity = true;
            }
          }
        }
      if (
        this.service.responseIO.data.AgentParty &&
        this.service.responseIO.data.AgentParty.EducationList != undefined
      )
        for (let education of this.service.responseIO.data.AgentParty.EducationList) {
          this.counterEducation = this.counterEducation + 1;
          if (this.counterEducation === 1) {
            if (this.CheckValidValues(education)) {
              this.headEducation = true;
            }
          }
        }

      if (
        this.service.responseIO.data.AgentParty &&
        this.service.responseIO.data.AgentParty.PartyEmployment != undefined
      )
        for (let partyEmployment of this.service.responseIO.data.AgentParty.PartyEmployment) {
          this.counterPartyEmployement = this.counterPartyEmployement + 1;
          if (this.counterPartyEmployement === 1) {
            if (this.CheckValidValues(partyEmployment)) {
              this.headPartyEmployment = true;
            }
          }
        }

      if (this.service.responseIO.data.QuestionList != undefined)
        for (let familyList of this.service.responseIO.data.QuestionList) {
          this.counterQuestionList = this.counterQuestionList + 1;
          if (this.counterQuestionList === 1) {
            if (this.CheckValidValues(familyList)) {
              this.headQuestion = true;
            }
          }
        }

      if (this.service.responseIO.data.FamilyList != undefined)
        for (let familyList of this.service.responseIO.data.FamilyList) {
          this.counterFamily = this.counterFamily + 1;
          if (this.counterFamily === 1) {
            if (this.CheckValidValues(familyList)) {
              this.headFamilyList = true;
            }
          }
        }

      if (this.service.responseIO.data.ReferenceList != undefined)
        for (let refyList of this.service.responseIO.data.ReferenceList) {
          this.counterReferenceList = this.counterReferenceList + 1;
          if (this.counterReferenceList === 1) {
            if (this.CheckValidValues(refyList)) {
              this.headRefList = true;
            }
          }
        }

      if (this.service.responseIO.data.TrainingList != undefined)
        for (let training of this.service.responseIO.data.TrainingList) {
          this.counterTrain = this.counterTrain + 1;
          if (this.counterTrain === 1) {
            if (
              training.trainingMode != null ||
              training.atiLocation != null ||
              training.trainingInstitute != null ||
              training.accreditationNumber != null ||
              training.trainingHoursCompleted != null ||
              training.trainingStartDt != null ||
              training.trainingEndDt != null
            ) {
              this.headTrain = true;
            }
          }
        }

      if (this.service.responseIO.data.PaymentList != undefined)
        for (let bank of this.service.responseIO.data.PaymentList) {
          this.counterBank = this.counterBank + 1;
          if (this.counterBank === 1) {
            if (
              bank.paymentModeCd != null ||
              bank.payeeName != null ||
              bank.payToCd != null ||
              bank.bankName != null ||
              bank.branchName != null ||
              bank.ifscCd != null ||
              bank.accountNum != null ||
              bank.micrCd != null ||
              bank.transactionStatusCd != null
            ) {
              this.headbank = true;
            }
          }
        }
      if (this.service.responseIO.data.ExamList != undefined)
        for (let exam of this.service.responseIO.data.ExamList) {
          this.counterExam = this.counterExam + 1;
          if (this.counterExam === 1) {
            if (
              exam.examCenter != null ||
              exam.examLanguage != null ||
              exam.examMode != null ||
              exam.examBody != null
            ) {
              this.headexam = true;
            }
          }
        }

      if (
        this.service.responseIO != null &&
        this.service.responseIO.data != null &&
        this.service.responseIO.data.LicenseList != null
      ) {
        for (let agency of this.service.responseIO.data.LicenseList) {
          this.counterAgency = this.counterAgency + 1;
          if (this.counterAgency === 1) {
            if (
              (agency.licenseType != null ||
                agency.issuingAuthority != null ||
                agency.licenseNum != null ||
                agency.effectiveFromDt != null ||
                agency.effectiveToDt != null ||
                agency.agentLicenseDOField01 != null) &&
              agency.licenseNum.length != 0
            ) {
              this.headagency = true;
            }
          }
        }
      }
      if (
        this.service.responseIO != null &&
        this.service.responseIO.data != null &&
        this.service.responseIO.data.AgentDetail != null
      ) {
        if (this.service.responseIO.data.AgentDetail.licenseApplied != null) {
          this.headagency = true;
        }
      }
      if (this.service.responseIO.data.NomineeList != undefined)
        for (let nom of this.service.responseIO.data.NomineeList) {
          this.counterNominee = this.counterNominee + 1;
          if (this.counterNominee === 1) {
            if (this.CheckValidValues(nom)) {
              this.headNominee = true;
            }
          }
        }
      // if (
      //   this.service.responseIO.data.NomineeList != undefined
      // ) {
      //   for (let nom of this.service.responseIO.data.NomineeList) {
      //     console.log(nom);

      //     this.counterNominee = this.counterNominee + 1;
      //     if (this.counterNominee === 1) {
      //       if (this.CheckValidValues(nom)) {
      //         this.headNominee = true;
      //       }
      //       // if (
      //       //   nom.nomineeName != null ||
      //       //   nom.genderCd != null ||
      //       //   nom.birthDt != null ||
      //       //   nom.agentNomineeDOField1 != null ||
      //       //   nom.agentNomineeDOField2 != null ||
      //       //   nom.address != null ||
      //       //   nom.agentNomineeDOField4 != null ||
      //       //   nom.agentNomineeDOField3 != null ||
      //       //   nom.contactNum != null ||
      //       //   nom.relationshipCd != null
      //       // ) {
      //       //   this.headNominee = true;
      //       // }
      //     }
      //   }
      // }
      if (this.service.responseIO.data.DocumentCategoryList != undefined)
        for (let document of this.service.responseIO.data.DocumentCategoryList) {
          if (document.DocumentList != null && document.DocumentList != undefined) {
            for (let doc of document.DocumentList) {
              this.counterDocument = this.counterDocument + 1;
              if (this.counterDocument === 1) {
                if (doc.selected == 'YES') {
                  this.headdocument = true;
                }
              }
            }
          }
        }
      if (
        this.service.responseIO.data.ServiceSignatureList != undefined &&
        this.service.responseIO.data.ServiceSignatureList.length != 0
      )
        for (let sign of this.service.responseIO.data.ServiceSignatureList) {
          if (sign.signature != null) {
            // for (let doc of document.DocumentList) {
            this.counterSignature = this.counterSignature + 1;
            if (this.counterSignature === 1) {
              // if (doc.selected == 'YES') {
              this.headSignature = true;
              // }
            }
            // }
          }
        }
    }
  }

  onClickImage(event, documentImage: any) {
    this.viewFile(documentImage.fileContents, documentImage.fileLocation);
  }

  onClickbutton() {
    window.close();
  }
  // onClickbutton(){
  //   window.close();
  // }

  isImageExtension(fileName: string): boolean {
    let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length);
    if (ext === 'docx' || ext === 'pptx' || ext === 'pdf') {
      return true;
    } else {
      return false;
    }
    // // let validExtensions:string[]=["jpg","bmp","gif","png"];
    // return this.imageExtension.includes(ext);
  }

  viewFile(fileContents: string, fileName: string) {
    // let fileDataType = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    let fileDataType = this.getFileDataType(fileName);
    fileContents = fileContents.replace('data:' + fileDataType + ';base64,', '');
    const byteArray = new Uint8Array(
      atob(fileContents)
        .split('')
        .map((char) => char.charCodeAt(0))
    );
    let blob = new Blob([byteArray], { type: fileDataType });
    let url = window.URL.createObjectURL(blob);
    var winHeight = $(window).height() - 200;
    var winWidth = $(window).width() - 600;
    var windowOptions =
      'toolbar=0,location=0,directories=0,status=1,menubar=0,scrollbars=1,resizable=1,width=' +
      winWidth +
      ',height=' +
      winHeight +
      ',left=100,top=100';
    window.open(url, '_blank');
    window.open(url, windowOptions);
    // window.open(url, 'win', windowOptions);
  }

  getFileDataType(fileName: string) {
    let ext = fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length).toLocaleLowerCase();
    let fileDataType = this.service.getValueFromLookup('FILEDATATYPE', ext);
    return fileDataType;
  }
  onAddNote() {
    $('#addNote').show();
    // $('.reviewBody').css("overflow", "hidden");
  }

  // onSendPDFClick() {
  //   this.createAndOpenPDF({
  //     h4: {
  //       fontSize: 10,
  //       color: '#003975',
  //       margin: [0, 0, 0, 10],
  //     },
  //     table: {
  //       fontSize: 10,
  //       marginLeft: 10,
  //       margin: [0, 0, 15, 5],
  //     },
  //   });
  // }
}
